/* eslint-disable import/no-unresolved */
//no-unresolved issue: https://github.com/nolimits4web/swiper/issues/5058

import { forwardRef, useImperativeHandle, useRef } from 'react';

import { Swiper, SwiperSlide, SwiperProps } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import type { Swiper as SwiperType } from 'swiper';
import styled from 'styled-components';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { useBreakpoint } from '@contexts/breakpoints';

const Wrapper = styled.div`
  position: relative;

  .swiper-button-next,
  .swiper-button-prev {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 50px;
    color: white;
    width: 50px;
    height: 50px;
    border: 2px solid ${({ theme }) => theme.palette.white};
    ::after {
      font-size: 32px;
    }
    :hover {
      background-color: rgba(0, 0, 0, 0.5);
    }
  }

  /* Allow pagination to render */
  .swiper-pagination {
    display: flex !important;
  }
`;

export interface CarouselHandle {
  slideTo: (index: number, speed?: number) => void;
}

const Carousel = forwardRef<CarouselHandle, SwiperProps>(
  (
    {
      breakpoints = {},
      navigation,
      slidesPerView = 1.1,
      modules = [Navigation, Pagination],
      ...props
    },
    ref
  ) => {
    const { xl: isDesktop } = useBreakpoint();
    const swiperRef = useRef<SwiperType | null>(null);

    useImperativeHandle(ref, () => ({
      slideTo: (index: number, speed = 300) => {
        swiperRef.current?.slideTo(index, speed);
      },
    }));

    return (
      <Wrapper>
        <Swiper
          spaceBetween={10}
          autoplay={false}
          slidesPerView={slidesPerView}
          navigation={navigation === undefined ? !isDesktop : navigation}
          modules={modules}
          breakpoints={breakpoints}
          onSwiper={(instance) => {
            swiperRef.current = instance;
          }}
          {...props}
        />
      </Wrapper>
    );
  }
);

export { SwiperSlide };
export default Carousel;
